import { conformArrayResponse, conformObjectResponse } from '~/api/utils';
import { axiosInstance } from '~/api/config/axios.config';
import { AKAsList, ContactsList } from '~/models/contacts.dto';
import { CreatorsListDto } from '~/models/creatorsList.dto';

export class CreatorApi {
    static async getListOfCreators() {
        return conformObjectResponse(axiosInstance.get('/catalogue/projectCreator/list'), CreatorsListDto);
    }

    static async getCreatorContacts(CreatorId: number) {
        return conformObjectResponse(axiosInstance.get('/catalogue/projectContact/list', { params: { ProjectId: CreatorId, pageSize: 50 } }), ContactsList);
    }

    static async getCreatorAKAs(CreatorId: number) {
        return conformArrayResponse(axiosInstance.get('/catalogue/projectContact/akalist', { params: { ProjectId: CreatorId } }), AKAsList);
    }
}
